import classes from './rightStyles.module.css'
const Wrong = () => {
    return (
        <div
            className={classes.wrong}
        >
        </div >
    )
}
export default Wrong;